module.exports = __webpack_public_path__ + "img/Weapon_288.5303515a.png";